<template>
  <div>
    <v-layout row>
      <v-icon @click="goBack">arrow_back</v-icon>
    </v-layout>
    <v-container>
      <v-layout row>
        <h2>
          Editing: {{ instructorToEdit.nameFirst + " " +
          instructorToEdit.nameLast }}
        </h2>
      </v-layout>
      <v-divider></v-divider>
      <v-layout column style="margin-top: 10px;">
        <v-form ref="editInstructorForm" v-model="valid">
          <v-layout column>
            <v-flex style="margin-bottom: 10px;">
              <v-img max-width="200px" max-height="250px" :src="instructorToEdit.imageUrl"></v-img>
            </v-flex>
            <v-flex>
              <v-text-field v-model="instructorToEdit.nameFirst" :rules="rules" label="First Name"></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field v-model="instructorToEdit.nameLast" :rules="rules" label="Last Name"></v-text-field>
            </v-flex>
            <v-flex>
              <v-textarea v-model="instructorToEdit.bio" :rules="rules" label="Bio"></v-textarea>
            </v-flex>
            <v-flex>
              <v-text-field v-model="instructorToEdit.priority" :rules="rules" type="number" label="Priority" id="priority"
                required></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-btn color="success" v-on:click="updateInstructor" :disabled="!valid">Save</v-btn>
          </v-layout>
        </v-form>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
  import {
    mapGetters,
    mapActions
  } from "vuex";

  export default {
    data() {
      return {
        valid: true,
        rules: [v => !!v || "Required"]
      };
    },
    computed: {
      ...mapGetters({
        instructorToEdit: "getInstructorToEdit"
      })
    },
    methods: {
      goBack() {
        this.$router.go(-1);
      },
      updateInstructor() {
        console.log("update");
        this.$store.dispatch("editInstructor", this.instructorToEdit);
        this.goBack();
      }
    }
  };

</script>

<style scoped`>
  h2 {
    font-weight: 400;
  }

  .name-span {
    font-weight: 400;
  }

</style>
